import { render, staticRenderFns } from "./DisplayHeader.vue?vue&type=template&id=52c21375"
import script from "./DisplayHeader.vue?vue&type=script&lang=js"
export * from "./DisplayHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports